import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilter,
  removeFilter,
  generateSalary, // ✅ NEW
  month,
  setMonth,
  year,
  setYear,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="monthFilter">
            <Form.Label>Month</Form.Label>
            <Form.Control
              type="number"
              min="1"
              max="12"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="yearFilter" className="mt-2">
            <Form.Label>Year</Form.Label>
            <Form.Control
              type="number"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div className="d-flex gap-2">
          <Button variant="primary" onClick={applyFilter}>
            Apply Filters
          </Button>
          <Button variant="secondary" onClick={removeFilter}>
            Remove Filters
          </Button>
        </div>
        <div className="d-flex gap-2">
          <Button variant="warning" onClick={generateSalary}>
            Generate Consolidated Data
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
